import apiCaller from "./api-caller";

const urlWithFilterParams = function (url, params) {
  const queryParams = new URLSearchParams();
  queryParams.set("page", params?.page || 1);

  for (const item of [
    "pageSize",
    "sortBy",
    "order",
    "startDate",
    "endDate",
    "idpresupuesto",
    "idpersonal",
    "filters",
  ]) {
    if (params && params[item]) {
      queryParams.set(item, params[item]);
    }
  }

  const queryString = queryParams.toString();
  return `${url}?${queryString}`;
};

class ReporteService {
  resource = "reportes";

  horasPorTarea(params) {
    return apiCaller
      .get(urlWithFilterParams(`/${this.resource}/horasPorTarea`, params))
      .then((response) => {
        return response.data;
      });
  }

  horasPorFecha(params) {
    return apiCaller
      .get(urlWithFilterParams(`/${this.resource}/horasPorFecha`, params))
      .then((response) => {
        return response.data;
      });
  }

  horasPorPresupuesto(params) {
    return apiCaller
      .get(urlWithFilterParams(`/${this.resource}/horasPorPresupuesto`, params))
      .then((response) => {
        return response.data;
      });
  }

  horasPorPersona(params) {
    return apiCaller
      .get(urlWithFilterParams(`/${this.resource}/horasPorPersona`, params))
      .then((response) => {
        return response.data;
      });
  }

  horasPorScheduler(params) {
    return apiCaller
      .get(urlWithFilterParams(`/${this.resource}/horasPorScheduler`, params))
      .then((response) => {
        return response.data;
      });
  }

  proyectosCSV(params) {
    return apiCaller
      .get(urlWithFilterParams(`/${this.resource}/proyectosCSV`, params))
      .then((response) => {
        return response.data;
      });
  }

  transaccionesPorFecha(params) {
    return apiCaller
      .get(urlWithFilterParams(`/${this.resource}/transaccionesPorFecha`, params))
      .then((response) => {
        return response.data;
      });
  }

  costoPersonalActivo = (params) => {
    return apiCaller
      .get(urlWithFilterParams("/reportes/costoPersonalActivo", params))
      .then((response) => {
        return response.data;
      });
  };
}

export default new ReporteService();
